import React, { useEffect, useState, useRef, useContext } from 'react';
import { IonItem, IonButton, IonSlides, IonGrid, IonTabs, IonTab, IonTabBar, IonTabButton, IonToolbar, IonTitle, IonContent, IonHeader, IonLabel, IonRouterOutlet, IonFooter, IonCard, IonModal, IonInfiniteScroll, IonInfiniteScrollContent, IonLoading } from '@ionic/react';
import { IonSlide, IonRow, IonCol, IonImg } from '@ionic/react';
import { useHistory} from "react-router-dom";

import '../css/zPublic.css';
import '../../css/layout.css';

import { Auth_MerchantID_context } from '../../../storeState/auth_merchantID_context';
import { MerchantLoginCredentials } from '../components/LoginCredentials_merchant';
import { RequestEstimateModal } from './Modal_RequestEstimate';
import { Enlarge_Image } from './EnlargeImage';
import {CachedImage} from './Component_CachedImage'; // Import CachedImage component


export function ProService_Homepage (props) {

        let authMerchant_objects = useContext(Auth_MerchantID_context);

        let [baseURL, setBaseURL ] = useState(authMerchant_objects.baseURL);


        let [customerRating, setCusotmerRating] = useState(null);
        let [viewHotelRooms_showcase, setViewHotelRooms_showcase] = useState([]);

        let [merchantLoginModal, setMerchantLoginModal] = useState(false);
        let [requestEstimateModal, setRequestEstimateModal] = useState(false);
        let {enlargeImageModal, setEnlargeImageModal} = useState(false);

        let [portfolioID, setPortfolioID] = useState(props.data.roomID);
        let [image, setImage] = useState(null);
        const [imageErrors, setImageErrors] = useState({});


        let [isloading, setLoading] = useState(false);

        const PAGE_SIZE = 5;         // how many images to show at a time
        let [visibleCount, setVisibleCount] = useState(PAGE_SIZE);
        let [hasMore, setHasMore] = useState(true);

        let history = useHistory();

        let currentShowcaseCategoryRef = useRef('main');


        let merchant_ID = props.data.companyId;




        useEffect(() => {


            //setLoading(true);


            setViewHotelRooms_showcase([]);

            let requestOptions3= {
                method: 'POST',
                credentials: 'include',
                headers: {'content-type': 'application/json' },
                body: JSON.stringify({
                    Tracker: "0002AA_pro_service",
                    merchantID: merchant_ID,
                    xShowcaseCategory: currentShowcaseCategoryRef.current.value
                }),
            }

            fetch(baseURL+'merchants_argsApp', requestOptions3)
            .then(res => res.text())
            .then(res => {

                let rows = res.toString().split('~~~');

                for (let rownum = 0; rownum < rows.length - 1; ++rownum)
                {
                    let cols = rows[rownum].split('|');

                        setViewHotelRooms_showcase((prevViewHotelRooms_showcase) => {
                            return prevViewHotelRooms_showcase.concat({
                                portfolioID: cols[0], 
                                image: cols[1]
                            })
                        });

                }

                //setLoading(false);
                setVisibleCount(PAGE_SIZE);
                setHasMore(true);
            });

        }, [])


        function enterModalHandler(event) 
        {


            setPortfolioID(event[1]);
            setImage(event[2]);
            //setEnlargeImageModal(event[0]);
            setRequestEstimateModal(event[0]);

        }
        const handleHomepage = () => {

            if(authMerchant_objects.authenticated == 'T2')
            {
                history.push('/proService_merchantMainPageApp'); 
                window.location.href = '/proService_merchantMainPageApp';
            }
      };

            return (
                <React.Fragment>
                <IonModal isOpen={true}>
                    <IonHeader>
                        <IonGrid >
                            <IonRow className='gh_homepage_top_links_row'>
                                <IonCol className='zPub_list_gridCol_title' style={{ textAlign: 'center' }}>{props.data.companyName}</IonCol>

                                <IonCol className='gh_homepage_top_links_col' size='3' style={{ textAlign: 'right' }}>
                                    {authMerchant_objects.authenticated == null && <IonButton  className='small_button' onClick={() => setMerchantLoginModal(true)}> Login </IonButton>}
                                    {authMerchant_objects.authenticated != null && <IonButton  className='small_button' onClick={() => handleHomepage()}> Homepage </IonButton>}                                
                                </IonCol>
                            </IonRow>
                            <IonRow >
                                <IonCol className='zPub_list_gridCol_address'>{props.data.companyAddressNumber + " " + props.data.companyStreetName+" * "+props.data.companyCity + ", " +props.data.companyCityDistrict}</IonCol>
                            </IonRow>
                            <IonRow >
                                <IonCol className='zPub_list_gridCol_address'>{props.data.companyEmail+" * "+props.data.companyPhoneNumber}</IonCol>
                            </IonRow>
                        </IonGrid>
                    </IonHeader>

                    {viewHotelRooms_showcase.length === 0 ? (
                    <div className='zList_companyImage_list'>
                        <IonCard className='card_merchantList'>
                        <div className='zList_img'>
                            <div className="dot-loader">
                            <span className="dot"></span>
                            <span className="dot"></span>
                            <span className="dot"></span>
                            <span className="dot"></span>
                            </div>
                        </div>
                        </IonCard>
                    </div>
                    ) : (
                    
                        <IonContent className='merchantList_Content_showcase'>
                        <div className='zShowcase_list'>

                                        {viewHotelRooms_showcase
                                        .slice(0, visibleCount)
                                        .map((detailData) => {  

                                        if (imageErrors[detailData.image]) {
                                        return null;
                                        }
                                        
                                        return (
                                            <IonCard className='card_merchantList_showcase' onClick={ () => enterModalHandler([true, detailData.portfolioID, detailData.image])}>
    
                                                <div className='zShowcase_img_div'>
                                                    
                                                {/*<CachedImage
                                                    imageUrl={detailData.image}
                                                    fileName={detailData.image}
                                                    className="zShowcase_img_inside"
                                                    alt="Pro Services Image"
                                                    onError={() => {
                                                    setImageErrors(prev => ({
                                                        ...prev,
                                                        [detailData.image]: true
                                                    }));
                                                    }}
                                                />*/}

                                                    {/*<IonImg src={`/api/image/${detailData.image}/${props.data.companySchema}`} />*/}

                                                    <img
                                                        src={detailData.image}
                                                        className="zShowcase_img_inside"
                                                        alt="ProService Image"
                                                        loading="lazy"
                                                        onError={() => {
                                                            setImageErrors(prev => ({
                                                                ...prev,
                                                                [detailData.image]: true
                                                            }));
                                                        }}
                                                    />
                                                </div>

                                            </IonCard>
                        );
                                    })}

                        </div>

                        <IonInfiniteScroll
                            onIonInfinite={(ev) => {
                            const newCount = visibleCount + PAGE_SIZE;

                            if (newCount >= viewHotelRooms_showcase.length) {
                                setVisibleCount(viewHotelRooms_showcase.length);
                                setHasMore(false);
                            } else {
                                setVisibleCount(newCount);
                            }

                            ev.target.complete();
                            }}
                            disabled={!hasMore}
                        >
                            <IonInfiniteScrollContent
                            loadingSpinner="bubbles"
                            loadingText="Loading more rooms..."
                            />
                        </IonInfiniteScroll>

                        {isloading == true && <IonLoading
                                                isOpen={isloading}
                                                message={'Please wait...'}
                                                duration={0} // Show until manually dismissed
                                            />}

                        </IonContent>
                    )}
                    <IonFooter class='hotelShowcaseFooter'>
                        <IonGrid>
                            <IonRow >
                                <IonCol className='zPub_gridCol'>{customerRating}</IonCol>
                            </IonRow>
                            <IonRow className='zPub_gridRow'>
                                <IonCol size='6'>
                                    <IonButton onClick={() => setRequestEstimateModal(true)}>Estimate</IonButton>
                                </IonCol>
                                {/*<IonCol size='4'>
                                    <IonButton href='https://bluefinhoteltest.com'>Site</IonButton>
                                </IonCol>*/}
                                <IonCol size='6'>
                                    <IonButton onClick={() => props.closeModal()}>Close</IonButton>
                                </IonCol>
                            </IonRow>
                        </IonGrid>
                    </IonFooter>

                    {merchantLoginModal == true && <MerchantLoginCredentials openModal={ merchantLoginModal } closeModal={() => setMerchantLoginModal(false)} ></MerchantLoginCredentials>}

                </IonModal>


                {enlargeImageModal == true && <Enlarge_Image openModal={ enlargeImageModal } closeModal={() => setEnlargeImageModal(false)} data={{
                                                                    companyID: props.data.companyId,
                                                                    portfolioID: portfolioID, 
                                                                    //image: image,
                                                                    }} ></Enlarge_Image>}

                {requestEstimateModal == true &&   <RequestEstimateModal openModal={ requestEstimateModal } closeModal={() => setRequestEstimateModal(false)} data={{
                        companyID: props.data.companyId,
                        companySchema: props.data.companySchema, 
                        }}></RequestEstimateModal> }
                        
            </React.Fragment>
    
            )
        //}


    }
